import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useFirestoreConnect, isLoaded, isEmpty } from "react-redux-firebase";
import LoadingIndicator from "../../../components/common/LoadingIndicator";
import BackButton from "../../../components/common/BackButton";
import OrdersTable from "../../../components/common/tables/OrdersTable";
import moment from "moment";
import "moment/locale/es";
import { Link } from "react-router-dom";
import { USER_ORDERS_PATH } from "../../../constants/paths";

import MdCreate from "react-ionicons/lib/MdCreate";

const ReceptionOrdersPage = () => {
  const [skip, setSkip] = useState(0);
  const [limit, setLimit] = useState(10);
  const [canNextPage, setCanNextPage] = useState(true);
  const [canPreviousPage, setCanPreviousPage] = useState(false);
  const [previousRef, setPreviousRef] = useState(null);
  const [previousOrders, setPreviousOrders] = useState({});

  useFirestoreConnect([
    {
      collection: "orders",
      limit: limit,
      startAfter: previousRef,
      orderBy: [["dateCreated", "desc"]],
    },
  ]);

  const orders = useSelector(({ firestore }) => {
    return firestore.ordered.orders;
  });

  useEffect(() => {
    if (skip === 0) {
      setPreviousRef(null);
    } else {
      const index =
        Math.ceil(skip / limit) > 0 ? Math.ceil(skip / limit) - 1 : 0;
      console.log(index);

      setPreviousRef(
        previousOrders[index][previousOrders[index].length - 1].dateCreated
      );
    }
  }, [skip]);

  useEffect(() => {
    if (isLoaded(orders)) {
      if (orders && orders.length === 0) {
        setCanNextPage(false);
      } else {
        if (orders && orders.length === limit) {
          setCanNextPage(true);
        } else {
          setCanNextPage(false);
        }

        const index =
          Math.ceil(skip / limit) >= 0 ? Math.ceil(skip / limit) : 0;
        console.log(index);
        const o = previousOrders;
        o[index] = orders;
        setPreviousOrders(o);
      }

      if (skip === 0) {
        setCanPreviousPage(false);
      } else {
        setCanPreviousPage(true);
      }
    }
  }, [orders]);

  if (!isLoaded(orders)) return <LoadingIndicator />;

  return (
    <div className={`px-16 py-8 text-gray-900 min-h-screen`}>
      <BackButton></BackButton>
      <h3 className="text-lg font-bold relative mt-4 mb-2">Órdenes</h3>
      <OrdersTable
        NoDataComponent={NoDataComponent}
        columns={columns}
        data={orders}
        className="table-auto w-full bg-white m-0 border-none"
        canNextPage={canNextPage}
        canPreviousPage={canPreviousPage}
        nextPage={() => {
          setSkip(skip + limit);
        }}
        previousPage={() => {
          setSkip(skip - limit);
        }}
        setPageSize={(n) => {
          setLimit(n);
        }}
        gotoPage={(n) => {
          setSkip(0);
        }}
        pageIndex={Math.ceil(skip / limit)}
      ></OrdersTable>
    </div>
  );
};

const columns = [
  {
    Header: "Datos",
    accessor: (values) => {
      return (
        <>
          <p className="text-gray-700 font-bold flex items-center">
            {values.client}
          </p>
          <p className="text-xs font-light text-gray-600">
            <span className="flex items-center">
              <DotComponent status={values.status}></DotComponent>
              <span className="capitalize mr-1">{values.status}</span>
              {" " + moment(values.dateCreated.toDate()).fromNow()}
            </span>
          </p>
        </>
      );
    },
  },
  {
    Header: "Estado",
    accessor: (values) => {
      return <span className="capitalize">{values.status}</span>;
    },
  },
  {
    Header: "Fecha de creación",
    accessor: (values) => {
      return (
        <span className="">
          {" " + moment(values.dateCreated.toDate()).format("LLL")}
        </span>
      );
    },
  },
  {
    Header: "Total",
    accessor: (values) => {
      const total =
        typeof values.cost === "string" ? parseFloat(values.cost) : values.cost;

      return <span>{total}</span>;
    },
  },
  {
    Header: "Acciones",
    accessor: (values) => {
      return (
        <Link
          className="py-2 px-3 bg-white border w-full inline-flex items-center text-center text-xs font-bold text-gray-800 uppercase rounded hover:bg-brand-700 hover:text-white hover:border-brand-900"
          to={`${USER_ORDERS_PATH}/${values.id}`}
        >
          <MdCreate className="fill-current mr-2"></MdCreate>Editar
        </Link>
      );
    },
  },
];

const NoDataComponent = () => {
  return (
    <div className="flex justify-center bg-white shadow-md py-16 flex-wrap text-gray-700">
      <h3 className="text-center text-4xl w-full font-bold">
        No se obtuvieron más órdenes
      </h3>
    </div>
  );
};

const DotComponent = ({ status }) => {
  let color;

  switch (status) {
    case "solicitada":
      color = "bg-gray-500";
      break;

    case "completada":
      color = "bg-green-500";
      break;

    case "aceptada":
      color = "bg-yellow-500";
      break;

    case "en curso":
      color = "bg-orange-500";
      break;

    case "cancelada":
      color = "bg-red-500";
      break;

    default:
      break;
  }
  return (
    <div className={`rounded-full w-2 h-2 ${color} inline-block mr-1`}></div>
  );
};

export default ReceptionOrdersPage;
